export interface User {
  userId: string;
  name: string;
  email: string;
  username: string;
  jobTitle: string;
  phone: string;
  imagePath: string;
  address: any;
}

export const users: User[] = [
  {
    userId: '65a6eb21-67b5-45c3-9af7-faca2d9b60d4',
    name: 'David Smith',
    email: 'Dessie7937@gmail.com',
    username: 'Dessie79',
    jobTitle: 'Web Developer',
    phone: '1-360-812-9380 x511',
    imagePath: 'assets/images/profile/user-2.jpg',
    address: '',
  },
  {
    userId: 'ee272550-36e8-4fe2-889d-c1ee701c5863',
    name: 'David Smith',
    email: 'Maya.Jakubowski@yahoo.com',
    jobTitle: 'Project Manager',
    username: 'Hortense99',
    phone: '712.916.2569 x0663',
    imagePath: 'assets/images/profile/user-5.jpg',
    address: {
      street: '9046 Allen Ferry',
      suite: 'Suite 429',
      city: 'Angushaven',
      state: 'Michigan',
      country: 'Costa Rica',
      zipcode: '92378-7065',
      geo: {
        lat: '78.1292',
        lng: '-134.6632',
      },
    },
  },
  {
    userId: 'ee272550-36e8-4fe2-889d-c1ee701c5866',
    name: 'Maya',
    email: 'Maya55_Dickens16@yahoo.com',
    jobTitle: 'Project Manager',
    username: 'maya',
    phone: '712.916.2569 x0663',
    imagePath: 'assets/images/profile/user-5.jpg',
    address: {
      street: '9046 Allen Ferry',
      suite: 'Suite 429',
      city: 'Angushaven',
      state: 'Michigan',
      country: 'Costa Rica',
      zipcode: '92378-7065',
      geo: {
        lat: '78.1292',
        lng: '-134.6632',
      },
    },
  },
  // {
  //   userId: '77f4b102-9df5-43ba-966a-6f816806c5e2',
  //   name: 'Maria Rodriguez',
  //   jobTitle: 'Product Manager',
  //   email: 'Pat_Zulauf81.Bartell86@gmail.com',
  //   username: 'Pat_Zulauf81',
  //   phone: '(058) 200-7342',
  //   imagePath: 'assets/images/profile/user-4.jpg',
  //   address: {
  //     street: '62268 Favian Coves',
  //     suite: 'Suite 993',
  //     city: 'Baumbachstad',
  //     state: 'New Mexico',
  //     country: 'Montserrat',
  //     zipcode: '44440',
  //     geo: {
  //       lat: '-34.7835',
  //       lng: '148.8907',
  //     },
  //   },
  // },
  {
    userId: '36a1ead7-57a0-4275-8a21-956194ab7cdf',
    name: 'Mary Smith',
    jobTitle: 'Web Developer',
    email: 'Solon.Bauch4_Rath@hotmail.com',
    username: 'Solon.Bauch4',
    phone: '789-914-4904 x173',
    imagePath: 'assets/images/profile/user-5.jpg',
    address: {
      street: '8153 Favian Walk',
      suite: 'Apt. 495',
      city: 'East Preston',
      state: 'Idaho',
      country: 'Iceland',
      zipcode: '24555',
      geo: {
        lat: '-42.5691',
        lng: '-2.5791',
      },
    },
  },
  {
    userId: 'b5899bef-d01e-42d8-af2d-edfb16b6b21e',
    name: 'Calista',
    jobTitle: 'Programmer',
    email: 'Calista_Mertz1757@hotmail.com',
    username: 'Calista_Mertz17',
    phone: '961-703-4134',
    imagePath: 'assets/images/profile/user-6.jpg',
    address: {
      street: '886 Wendy Circles',
      suite: 'Apt. 933',
      city: 'Lake Loy',
      state: 'Rhode Island',
      country: 'South Africa',
      zipcode: '65261',
      geo: {
        lat: '-58.9245',
        lng: '-43.6330',
      },
    },
  },
  {
    userId: '7d910620-84e1-49fc-951e-d375587b8189',
    name: 'Jackeline',
    jobTitle: 'Sales Executive',
    email: 'Jackeline.Abshire_Dach@yahoo.com',
    username: 'Jackeline.Abshire',
    phone: '(326) 903-5706 x6854',
    imagePath: 'assets/images/profile/user-7.jpg',
    address: {
      street: '416 Cathy Spur',
      suite: 'Apt. 431',
      city: 'North Camila',
      state: 'Pennsylvania',
      country: 'Libyan Arab Jamahiriya',
      zipcode: '31751',
      geo: {
        lat: '64.0673',
        lng: '154.7671',
      },
    },
  },
  {
    userId: 'afdb5033-5bcc-4cec-b932-353a83410b44',
    name: 'Jamey',
    jobTitle: 'PHP Developer',
    email: 'Jamey_Grant_Cruickshank73@gmail.com',
    username: 'Jamey_Grant',
    phone: '545-939-2404 x32373',
    imagePath: 'assets/images/profile/user-8.jpg',
    address: {
      street: '38372 Mante Glen',
      suite: 'Suite 090',
      city: 'Robertsside',
      state: 'Texas',
      country: 'Equatorial Guinea',
      zipcode: '86558-7214',
      geo: {
        lat: '-55.0222',
        lng: '-100.5977',
      },
    },
  },
  {
    userId: '60d07662-bfec-42c7-b044-c81bc4ff8c7a',
    name: 'Barton',
    email: 'Barton85_Emard@gmail.com',
    jobTitle: 'Web Developer',
    username: 'Barton85',
    phone: '(979) 560-8322 x174',
    imagePath: 'assets/images/profile/user-d1.jpg',
    address: {
      street: '185 Florine Spurs',
      suite: 'Suite 178',
      city: 'Port Carrollburgh',
      state: 'Alaska',
      country: 'Saint Barthelemy',
      zipcode: '30126',
      geo: {
        lat: '24.0545',
        lng: '-88.8499',
      },
    },
  },
  {
    userId: '5c44b666-baca-4f18-a3cb-23068c6edc14',
    name: 'Gloria',
    jobTitle: 'Assets',
    email: 'Gloria78.Nicolas83@hotmail.com',
    username: 'Gloria78',
    phone: '188.890.3246',
    imagePath: 'assets/images/profile/user-d2.jpg',
    address: {
      street: '643 Arch Mews',
      suite: 'Apt. 171',
      city: 'Wymanland',
      state: 'Indiana',
      country: 'Jersey',
      zipcode: '73594-9840',
      geo: {
        lat: '-70.9980',
        lng: '-151.6234',
      },
    },
  },
  {
    userId: '46d6f992-5729-4588-b7f8-ce74f21157ba',
    name: 'Olin',
    jobTitle: 'Finaice',
    email: 'Olin.Robel49.Schowalter24@yahoo.com',
    username: 'Olin.Robel49',
    phone: '1-982-234-7756',
    imagePath: 'assets/images/profile/user-d3.jpg',
    address: {
      street: '0813 Mayer Greens',
      suite: 'Apt. 551',
      city: 'Bergstromburgh',
      state: 'Ohio',
      country: 'Anguilla',
      zipcode: '42502-9731',
      geo: {
        lat: '-48.2520',
        lng: '60.6556',
      },
    },
  },
  {
    userId: 'bd30e201-cceb-410e-8497-a4072bc399f5',
    name: 'Rollin',
    jobTitle: 'Supporting',
    email: 'Rollin43_Fay@yahoo.com',
    username: 'Rollin43',
    phone: '477-651-5715 x502',
    imagePath: 'assets/images/profile/user-d4.jpg',
    address: {
      street: '5704 Spinka Causeway',
      suite: 'Suite 388',
      city: 'Pollyburgh',
      state: 'Arizona',
      country: 'Virgin Islands, U.S.',
      zipcode: '45048',
      geo: {
        lat: '55.3046',
        lng: '3.8129',
      },
    },
  },
  {
    userId: 'da95e977-cd54-4077-a767-1b7f33ef6919',
    name: 'Murl',
    email: 'Murl_Abshire41_Lakin@hotmail.com',
    username: 'Murl_Abshire41',
    jobTitle: 'Web Developer',
    phone: '107-733-1219 x0615',
    imagePath: 'assets/images/profile/user-d5.jpg',
    address: {
      street: '4880 Tanner Circles',
      suite: 'Apt. 994',
      city: 'Bauchside',
      state: 'Ohio',
      country: 'Uganda',
      zipcode: '11259',
      geo: {
        lat: '11.6209',
        lng: '-45.1766',
      },
    },
  },
  {
    userId: '6124d4e8-77ed-4b34-868d-d312bfab5de2',
    name: 'Breanna',
    jobTitle: 'Web Developer',
    email: 'Breanna.Bartoletti21@hotmail.com',
    username: 'Breanna.Bartoletti',
    phone: '645.045.0876 x35882',
    imagePath: 'assets/images/profile/user-profile.png',
    address: {
      street: '431 Grimes Common',
      suite: 'Apt. 530',
      city: 'East Lunahaven',
      state: 'Virginia',
      country: 'Hungary',
      zipcode: '12012-3038',
      geo: {
        lat: '29.7991',
        lng: '-70.4033',
      },
    },
  },
  {
    userId: 'eef93cb1-7766-4413-a5cf-ecbf71fa3674',
    name: 'Maya',
    email: 'Maya55_Dickens16@yahoo.com',
    username: 'Maya55',
    jobTitle: 'Web Developer',
    phone: '199.260.3770 x2815',
    imagePath: 'assets/images/profile/user-4.jpg',
    address: {
      street: '58581 Guillermo Springs',
      suite: 'Suite 574',
      city: 'Cloydville',
      state: 'Delaware',
      country: 'Saint Barthelemy',
      zipcode: '95633-3394',
      geo: {
        lat: '-57.5740',
        lng: '104.5634',
      },
    },
  },
  {
    userId: '899d0e31-b71e-4d95-a8a0-6a8bceb314bd',
    name: 'James Smith',
    jobTitle: 'Web Developer',
    email: 'abc@company.com',
    username: 'Santiago41',
    phone: '1-489-921-2159 x8655',
    imagePath: 'assets/images/profile/user-6.jpg',
    address: {
      street: '7868 Windler Dam',
      suite: 'Suite 876',
      city: 'Port Emmetfurt',
      state: 'Alabama',
      country: 'Belarus',
      zipcode: '63739-4581',
      geo: {
        lat: '-28.7166',
        lng: '-167.7070',
      },
    },
  },
  {
    userId: 'a41c6c4a-9cb1-45d1-8c6f-091044ba51ff',
    name: 'Maria Rodriguez',
    jobTitle: 'Web Developer',
    email: 'Maria Rodriguez10.Macejkovic@yahoo.com',
    username: 'Maria Rodriguez10',
    phone: '445-761-1519',
    imagePath: 'assets/images/profile/user-8.jpg',
    address: {
      street: '146 Lemke Mountains',
      suite: 'Apt. 407',
      city: 'North Toyfort',
      state: 'Connecticut',
      country: 'Senegal',
      zipcode: '90211-1855',
      geo: {
        lat: '-56.3849',
        lng: '-167.1372',
      },
    },
  },
  {
    userId: '3782c174-1f2c-4dc4-b75d-0bedf400e023',
    name: 'Lora',
    jobTitle: 'Web Developer',
    email: 'Lora_Kessler586@hotmail.com',
    username: 'Lora_Kessler5',
    phone: '315-215-2852 x69280',
    imagePath: 'assets/images/profile/user-3.jpg',
    address: {
      street: '4018 Willms Turnpike',
      suite: 'Suite 573',
      city: 'Leuschkemouth',
      state: 'Kentucky',
      country: 'Dominican Republic',
      zipcode: '70964',
      geo: {
        lat: '80.2384',
        lng: '38.1323',
      },
    },
  },
];

export function getUser(uid: string): User | null {
  // tslint:disable-next-line: no-shadowed-variable
  const u = users.find((u) => {
    return u.userId === uid;
  });

  if (u === undefined) {
    return null;
  }
  return u;
}
